export const OPERATIONAL_PROCESS_TYPES = [
  'EXPENSE_CONFIRMATION',
  'INCIDENT_RESOLUTION',
  'DOCUMENT_COLLECTION',
  'DOWNTIME_REVIEW',
  'COMPLETION_REVIEW'
] as const;

export type OperationalProcessType = (typeof OPERATIONAL_PROCESS_TYPES)[number];

export const PROCESS_TYPE_LABELS: Record<OperationalProcessType, string> = {
  EXPENSE_CONFIRMATION: 'Подтверждение расходов',
  INCIDENT_RESOLUTION: 'Инцидент',
  DOCUMENT_COLLECTION: 'Документы',
  DOWNTIME_REVIEW: 'Простой',
  COMPLETION_REVIEW: 'Завершение'
};

export const PROCESS_STATUS_LABELS: Record<string, string> = {
  CREATED: 'создан',
  ACTIVE: 'активен',
  WAITING: 'ожидает',
  COMPLETED: 'завершён',
  CANCELLED: 'отменён',
  FAILED: 'ошибка'
};
